























































import { Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { mdiAccount } from '@mdi/js';
import UserMenu from '@/components/UserMenu.vue';
import ConversationList from '@/components/ConversationList.vue';
// import TrainingNavList from '@/components/TrainingNavList.vue';
import HiveFooter from './components/HiveFooter.vue';

export default Vue.extend({
  components: {
    UserMenu,
    ConversationList,
    // TrainingNavList,
    HiveFooter
  },
  methods: {
    onUserIcon(event: MouseEvent) {
      if (!this.$store.state.user || !this.$store.state.user.email) {
        this.$router.push('/login');
      } else {
        this.userMenu = {
          x: event.clientX,
          y: event.clientY
        };
      }
    }
  },
  computed: mapState([
    'bots'
  ]),
  /*computed: {
    bots() {
      console.info('get bots from store:', this.$store.state);
      return this.$store.state.bots;
    }
  },*/
  data() {
    return {
      userMenu: {},
      drawer: true,
      expandedPanel: 0,
      messageCount: 0,
      activeBot: 0,
      icons: {
          account: mdiAccount
      }
    };
  }
});
